module.exports = __webpack_public_path__ + "img/DAY2-1.7a5cc84a.jpg";